var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#707070}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7976",
    transform: "translate(-3.75 -3.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_178",
    d: "M0 0L13.231 0",
    className: "cls-1",
    transform: "translate(8.519 4.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_179",
    d: "M0 0L13.231 0",
    className: "cls-1",
    transform: "translate(8.519 8.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_180",
    d: "M0 0L13.231 0",
    className: "cls-1",
    transform: "translate(8.519 12.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_181",
    d: "M0 0L13.231 0",
    className: "cls-1",
    transform: "translate(8.519 16.721)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_44",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-173.5 13.882l-.69-1.382h1.381l-.637 1.274-.001.003-.053.105zm.691-11.382h-1.382l.69-1.382.692 1.382z",
    transform: "translate(178.75 3.221)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M-173.5 15l-1.5-3h1V3h-1l1.5-3 1.5 3h-1v9h1l-1 2-.5 1z",
    transform: "translate(178.75 3.221)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHeight);
export default __webpack_public_path__ + "static/media/LineHeight.c201f342fac9bc45d050e38594e2dea9.svg";
export { ForwardRef as ReactComponent };